import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { User } from '@app/_models';
import { UserService } from '@app/_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { LogService } from '../../../_shared/log.service'

@Component({
  selector: 'app-user-master',
  templateUrl: './user-master.component.html',
  styleUrls: ['./user-master.component.css']
})
export class UserMasterComponent implements OnInit {

  users: User[];
  userId: number;
  dtTrigger: Subject<any> = new Subject<any>();
  strMessage;
  delMessage;
  successOrFailure;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  getresponse: any;

  title = 'docVerificationList';
  dtOptions: DataTables.Settings = {};

  constructor(private eventService: LogService, private userService: UserService,
    private modalService: NgbModal) { }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };

    // this.collegeService.getCollege()
    this.userService.getUsers()
      .pipe(first())
      .subscribe(
        data => {
          console.log("getAllUsers response---", data)
          this.users = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )

  }

  deleteUserData(id) {
    this.userId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteUser(id) {
    console.log(id);

    this.userService.deleteUser( this.userId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("deleteUser response---", data)

          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.successOrFailure="Success";
            this.delMessage = "User Deleted Successfully."
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
          
            for (let i = 0; i < this.users.length; ++i) {
              if (this.users[i].id ===  this.userId) {
                this.users.splice(i, 1);
              }
            }

            this.modalService.open(this.showModalBoxTemplate);
            
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.successOrFailure="Failure";
            this.delMessage = this.getresponse.respData;
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            // this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            // this.modalService.dismissAll(this.showModalBoxTemplate);
          }
        },
        error => {
          console.log(error)
        }
      )

  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('16');
  }

}
